import { Button, Icon } from '@chakra-ui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';

export const BackToLoginButton = () => {
  const history = useHistory();
  return (
    <Button
      width="full"
      mt={4}
      leftIcon={<Icon as={ArrowLeft} />}
      onClick={() => history.push('/login')}
    >
      Zurück zum Login
    </Button>
  );
};
